import { i18n } from "@/i18n";
import { analyticsTagsConstantes } from "@/constantes/analyticsTags";

export default {
  path: "/studea-manager/driver-licence",
  name: "driverLicenceView",
  component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutWithErrorView.vue"),
  meta: {
    authRequired: true,
    title: i18n.global.t("studea_manager.driver_licence.title"),
    breadcrumb: true,
  },
  children: [
    {
      path: "list",
      name: "driverLicenceList",
      component: () =>
        import(/* webpackChunkName: "driver-licence" */ "@/views/DriverLicence/DriverLicenceListView.vue"),
      meta: {
        authRequired: true,
        title: i18n.global.t("studea_manager.driver_licence.list"),

        breadcrumb: true,
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_DASHBOARD_DRIVING_LICENSE_AID,
      },
    },
  ],
};
